// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Breadcrumb-module-breadcrumb {
  display: flex;
  gap: 5px;
  align-items: center;
  list-style: none;
  padding: 0;
}

.Breadcrumb-module-breadcrumb > svg {
  width: 20px;
  height: 20px;
  fill: var(--text);
}

.Breadcrumb-module-breadcrumb > a {
  color: var(--text);
  text-decoration: none;
  display: flex;
  gap: 5px;
}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/Breadcrumb/Breadcrumb.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,QAAQ;AACV","sourcesContent":[".breadcrumb {\r\n  display: flex;\r\n  gap: 5px;\r\n  align-items: center;\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.breadcrumb > svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  fill: var(--text);\r\n}\r\n\r\n.breadcrumb > a {\r\n  color: var(--text);\r\n  text-decoration: none;\r\n  display: flex;\r\n  gap: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
export var breadcrumb = `Breadcrumb-module-breadcrumb`;
export default ___CSS_LOADER_EXPORT___;
